export interface AiCadLaunchSession {
    readonly token: string;
    readonly expiresAt: string;
}
